import { AxiosProgressEvent } from "axios";
import apiClient from "services/httpClient/userClient";
import { AccountNumberConfirmResponse } from "./models";
import { uploadCorporateDocument } from "./document";
import { rejectFailedStatus } from "services/httpClient/rejectFailedStatus";

export type uploadKey = {
  progress?: string | number;
  success?: boolean;
  error?: boolean;
};
export const addCorporateDirector = (payload: any) =>
  apiClient.post("/api/CorporateDirector", payload).then(rejectFailedStatus);

export const updateCorporateDirector = (payload: any) =>
  apiClient.put("/api/CorporateDirector", payload).then(rejectFailedStatus);

export const getCorporateDirector = () =>
  apiClient.get("/api/CorporateDirector").then(rejectFailedStatus);

export const deleteCorporateDirector = (directorId: string) =>
  apiClient
    .delete(`/api/CorporateDirector/${directorId}`)
    .then(rejectFailedStatus);

// GET CorporateDirector and GET BankAccount are documented as returning one
// record. Read Data as a list either way.
export const asList = <T>(data: T | T[] | null | undefined): T[] =>
  Array.isArray(data) ? data : data ? [data] : [];


//  End of Corporate Director

export const addCorporateDocument = (
  payload: any,
  func: (val: uploadKey) => void
) => {
  const config = {
    onUploadProgress: function (progressEvent: AxiosProgressEvent) {
      var percentCompleted = Math.round(
        (progressEvent.loaded * 100) / (progressEvent.total ?? 100)
      );
      func({ progress: percentCompleted });
    },
  };
  uploadCorporateDocument(payload, config)
    .then((data) => {
      func({ success: true });
    })
    .catch((err) => {
      func({ error: true });
    });
};

// export const getCorporateDocumentTypes = () =>
//   apiClient.get("/api/Document/get-corporate-document-types");

export const getCorporateDocument = (documentId: string) =>
  apiClient.get(`/api/Document/get-corporate-document/${documentId}`);

export const deleteCorporateDocument = (documentId: string) =>
  apiClient.delete(
    `/api/Document/delete-corporate-document/${documentId}`
  );
// End of Corporate Document

export const addBankAccount = (payload: any) =>
  apiClient.post("/api/BankAccount", payload);

export const updateBankAccount = (payload: any) =>
  apiClient.put("/api/BankAccount", payload);

export const getBankAccount = () => apiClient.get("/api/BankAccount");
export const getBanks = () => apiClient.get("/api/BankAccount/banks");

export const deleteBankAccount = (accountId: string) =>
  apiClient.delete(`/api/BankAccount/${accountId}`);

export const getAccountNameEnquiry = (payload: {
  account_no: string;
  bank_code?: string;
}) => apiClient.post<AccountNumberConfirmResponse>("/api/BankAccount/account-name-enquiry", payload)
.catch((err) => {
  return 'Unable to confirm account.'
});
